// @flow

import * as React from 'react';
import { graphql, useFragment } from 'react-relay';
import { useLocale } from '../../hooks/locale';
import { useRouter } from '../../controls/router';
import { StructuredData } from '../../controls/structured-data';
import { makeListingHref } from './listing-href';
import { useListingStructuredData } from './useListingStructuredData';
import type { AggregatesListingStructuredData_listing$key } from './__generated__/AggregatesListingStructuredData_listing.graphql';

type Props = {|
  listing: AggregatesListingStructuredData_listing$key,
|};

export const AggregatesListingStructuredData = (props: Props): React.Node => {
  const { t } = useLocale();
  const router = useRouter();
  const listing = useFragment(
    graphql`
      fragment AggregatesListingStructuredData_listing on AggregatesListing {
        ...useListingStructuredData_listing
        offerType
        compositePropertyType
        slug
        description
        translatedDescription
      }
    `,
    props.listing,
  );

  const href = makeListingHref({
    offerType: listing.offerType,
    compositePropertyType: listing.compositePropertyType,
    slug: listing.slug,
  });

  const listingStructuredData = useListingStructuredData(
    t,
    router.getUrl(href).absolute,
    listing,
  );

  return (
    <StructuredData
      type={listingStructuredData.type}
      properties={{
        ...listingStructuredData.properties,
        description: listing.translatedDescription ?? listing.description ?? '',
      }}
    />
  );
};
